type RevenueLocationLike = Partial<
  Pick<Location, 'pathname' | 'host' | 'hostname'>
>;

const REVENUE_ROOT_PATHS = ['/revenue', '/revpro'] as const;

export function isOneIdHost(host?: string | null): boolean {
  return (host ?? '').toLowerCase().startsWith('one');
}

export function isRevenueNavigationPath(pathname?: string | null): boolean {
  const normalizedPathname = pathname ?? '';

  return REVENUE_ROOT_PATHS.some(
    (rootPath) =>
      normalizedPathname === rootPath ||
      normalizedPathname.startsWith(`${rootPath}/`) ||
      normalizedPathname.includes(`${rootPath}/`),
  );
}

export function isRevenueLocation(
  location?: RevenueLocationLike | null,
): boolean {
  return (
    isRevenueNavigationPath(location?.pathname) ||
    isOneIdHost(location?.host || location?.hostname)
  );
}
